import api from "./api";



const listPreference = (search) => {
  return api
    .get("/preference", {
      params: {
        ...search,
      },
    })
    .then((response) => {
      return response.data;
    });
};


const getPreference = (id) => {
  return api.get("/preference/" + id).then((response) => {
    return response.data;
  });
};


const getPreferenceFilterValues = (search) => {

  return api.get("/preference/filtervalues",{
    params: {
      ...search
    }
  })
  .then((response) => {
    return response.data;
  });
};

const getPreferenceUi = () => {
  return api.get("/preference/ui")
  .then((response) => {
    return response.data;
  });
};


const updatePreference = (preference) => {
  return api
    .patch("/preference", {
      ...preference,
    })
    .then((response) => {
      return response.data;
    });
};

const updatePreferenceByUser = (preference) => {
  return api
    .patch("/preference_by_user", {
      ...preference,
    })
    .then((response) => {
      return response.data;
    });
};

// The caller's own preference of this name. "@me" is resolved to the authenticated user by the
// kernel (ListPreference), matching updatePreferenceByUser, which files a username-less save
// under that same user. Without it every user read one shared preference.
const getPreferenceByName = (name) => {
  return api
    .get("/preference", {
      params: { filter: `[name]=${name}|[userName]=@me`, page_size: 1 },
    })
    .then((response) => {
      return response.data;
    });
};

const PreferenceService = {
  listPreference,
  getPreference,
  getPreferenceFilterValues,
  getPreferenceUi,
  updatePreference,
  updatePreferenceByUser,
  getPreferenceByName,
};

export default PreferenceService;
